var _style, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSearchLoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000147197180434451992460000000111887867349260177_);}\r\n\t.st1{fill:#27395F;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_14",
    transform: "translate(-977 -438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_13",
    transform: "translate(977 438)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 20,
    height: 20
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150809296716924307650000011342608883732377256_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_12",
    style: {
      clipPath: "url(#SVGID_00000150809296716924307650000011342608883732377256_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_10",
    className: "st1",
    d: "M10,12.22c-1.23,0-2.22-1-2.22-2.22c0-1.23,1-2.22,2.22-2.22c1.23,0,2.22,1,2.22,2.22 C12.22,11.23,11.23,12.22,10,12.22 M10,20c-2.47,0.04-4.87-0.87-6.69-2.54c-1.85-1.62-3.02-3.89-3.25-6.35h2.28 c0.22,1.86,1.14,3.57,2.57,4.78c1.41,1.24,3.22,1.92,5.1,1.89c2.07,0.04,4.07-0.78,5.51-2.26c1.48-1.45,2.3-3.44,2.26-5.51 c0.04-2.07-0.78-4.07-2.26-5.51C14.07,3,12.07,2.18,10,2.22c-1.25-0.01-2.48,0.3-3.58,0.89C5.31,3.7,4.35,4.54,3.61,5.56h3.06 v2.22H0V1.11h2.22v2.61c0.93-1.17,2.11-2.11,3.46-2.75C7.03,0.33,8.51-0.01,10,0c1.34-0.01,2.67,0.26,3.9,0.79 c2.39,1.02,4.29,2.92,5.31,5.31c0.53,1.23,0.8,2.56,0.79,3.9c0.01,1.34-0.26,2.67-0.79,3.9c-1.02,2.39-2.92,4.29-5.31,5.31 C12.67,19.74,11.34,20.01,10,20"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSearchLoad);
export default __webpack_public_path__ + "static/media/ico_search_load.2a8596c3b5a6462b550a573776fee05c.svg";
export { ForwardRef as ReactComponent };